import { AnyFunction } from 'types';

/**
 * It  creates a throttled version of a function that limits its execution to at most once within a specified time interval. The function is invoked on the trailing edge of the wait timeout if the throttled function was called more than once during the wait period.
 * @param func - The function to throttle.
 * @param wait - The time (in milliseconds) to wait before allowing the function to be called again.
 * @returns A new throttled function that will invoke the original func only if the specified wait time has passed since the last invocation.
 */
export function throttleLeading(func: () => void, wait: number) {
  let lastCallTime = 0;

  return function (this: any, ...args: any[]) {
    const currentTime = Date.now();

    if (currentTime - lastCallTime >= wait) {
      func.apply(this, args);
      lastCallTime = currentTime;
    }
  };
}

export function debounce(func: AnyFunction, delay: number): AnyFunction {
  let timeoutId: NodeJS.Timeout;

  return function (this: any, ...args: any[]) {
    // Thêm type annotation cho this
    clearTimeout(timeoutId);
    timeoutId = setTimeout(() => {
      func.apply(this, args);
    }, delay);
  };
}
